<template>
    <div>
        <b-breadcrumb :items="items"></b-breadcrumb>
        <div class="container-fluid text-center" style="background-color: white">
            <br/>
            <h2>เพิ่มโปรโมชั่น</h2>
            <br/>
            <div class="row form-group">
                <b-col class="col-sm-3 text-right">ชื่อโปรโมชั่น</b-col>
                <b-col class="col-sm-6">
                    <input class="form-control"
                           v-model="form.name"
                           type="text"/>
                </b-col>
            </div>
            <div class="row form-group">
                <b-col class="col-sm-3 text-right">รายละเอียด</b-col>
                <b-col class="col-sm-6">
                    <textarea class="form-control"
                              v-model="form.description">
                    </textarea>
                </b-col>
            </div>
            <div class="row form-group">
                <b-col class="col-sm-3 text-right">สถานะ</b-col>
                <b-col class="col-sm-6">
                    <b-form-select :options="status_promotion"
                                   v-model="form.status_id"></b-form-select>
                </b-col>
            </div>
            <div class="row form-group">
                <b-col class="col-sm-3 text-right">วันที่จัดโปรโมชั่น</b-col>
                <b-col class="col-sm-3">
                    <date-picker
                        class="w-100"
                        :format="changeFormat"
                        :lang="lang"
                        v-model="form.start_date"
                        placeholder="วันที่เริ่มต้น">
                    </date-picker>
                </b-col>
                <b-col class="col-sm-3">
                    <date-picker
                        class="w-100"
                        :format="changeFormat"
                        :lang="lang"
                        v-model="form.end_date"
                        placeholder="วันที่สิ้นสุด">
                    </date-picker>
                </b-col>
            </div>
            <div class="row form-group">
                <b-col class="col-sm-3 text-right">เงื่อนไขโปรโมชั่น</b-col>
                <b-col class="col-sm-6">
                    <b-form-select :options="promotion"
                                   v-model="form.condition"></b-form-select>
                </b-col>
            </div>
            <div class="row form-group">
                <div class="col-3 text-right">โปรโมชั่นสำหรับเซลล์(ไม่จำเป็นต้องเลือก)</div>
                <div class="col-6">
                    <b-form-select :options="optionSeller" v-model="form.sale_id"></b-form-select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2"></div>
                <div class="col-sm-4 form-group row form-inline">
                    <div class="text-right">
                        <span>จำนวนขั้นต่ำ</span>
                        <input type="number"
                               v-model="form.quantity"
                               class="form-control w-50"/>
                        <b-form-select :options="unit"
                                       v-model="form.discount_status_id"
                                       class="w-25">
                        </b-form-select>
                    </div>
                </div>
                &nbsp;
                <div class="col-sm-4 form-group row form-inline">
                    <div class="text-left">
                        <span>ส่วนลด</span>
                        <input type="number"
                               v-model="form.discount"
                               class="form-control w-50"/>
                        <b-form-select :options="unit_price"
                                       v-model="form.discount_status_id"
                                       class="w-25">
                        </b-form-select>
                        &nbsp;
                    </div>
                </div>
            </div>
            <!--table products-->
            <div>
                <div class="row">
                    <b-col class="col-sm-3 text-right">
                        เลือกสินค้าสำหรับโปรโมชั่น
                    </b-col>
                    <b-col class="col-sm-8 form-inline">
                        <input type="text" class="form-control"
                               v-model="search_product.code"
                               placeholder="รหัสสินค้า"/>&nbsp;
                        <b-form-select :options="optionProductType"
                                       v-model="search_product.type"></b-form-select>&nbsp;
                        <button class="btn btn-primary"
                                @click="searchProduct">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                    </b-col>
                </div>
                <div class="row">
                    <b-col class="col text-center">
                        <table class="table table-bordered text-center">
                            <thead>
                            <tr>
                                <th>
                                    <input type="checkbox" v-model="selectAll"/>
                                </th>
                                <th>รหัสสินค้า</th>
                                <th>ชื่อสินค้า</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="data in productAll">
                                <td><input type="checkbox" v-model="form.checked"
                                           :value="data"/></td>
                                <td>{{ data.sku }}</td>
                                <td>{{ data.name }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </b-col>
                </div>
                <div v-if="productAll.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getProductPage">
                    </vue-pagination>
                </div>
                <div>
                    <table class="table table-bordered" style="width: 500px">
                        <tr>
                            <th>ลำดับ</th>
                            <th>รายการสินค้าที่เลือก</th>
                        </tr>
                        <tr v-for="(data,index) in form.checked">
                            <td>{{ ++index }}</td>
                            <td>{{ data.sku }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <br/>
            <b-row>
                <div class="col text-center">
                    <button
                        :disabled="form.onSave"
                        type="button"
                        @click="savePromotion"
                        class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button
                        type="button"
                        @click="goToPromotionList"
                        class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </b-row>
            <br/>
        </div>
        <!--        <pre class="alert-warning">{{productAll}}</pre>-->
        <!--<pre class="alert-success">{{form.checked.length}}</pre>-->
        <!--<pre class="alert-primary">{{form.checked}}</pre>-->
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import {mapState} from "vuex";
import Button from "bootstrap-vue/es/components/button/button";
import Table from "bootstrap-vue/src/components/table/table";
import moment from "moment";
import VuePagination from "../../Pagination";

export default {
    name: "promotion-form",
    components: {
        VuePagination,
        Table,
        Button,
        DatePicker
    },
    props: {
        id: {default: null}
    },
    created() {
        this.$store.dispatch("Products/setProducts", 1).then(res => {
            this.productAll = res.data;
            this.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        });
        this.$store.dispatch('ProductType/get');
        this.$store.dispatch('Promotion/getConditionPro');
        if (!this.id) {
            this.$store.dispatch("Promotion/clearData");
        }
        this.$store.dispatch("Seller/get");
    },
    data() {
        return {
            productAll: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            status_promotion: [
                {value: 0, text: "InActive"},
                {value: 1, text: "Active"}
            ],
            discount: {
                quantity_min: "",
                unit_id: 1,
                discount: "",
                discount_status_id: 1,
            },
            search_product: {
                code: "",
                type: ""
            },
            unit: [{
                value: 1, text: "ลัง"
            }],
            unit_price: [
                {value: 1, text: "฿"},
                {value: 2, text: "%"},
            ],
            details: [],
            items: [
                {
                    text: 'รายการโปรโมชั่น',
                    to: {name: "promotions-list"}
                },
                {
                    text: 'เพิ่มเติม',
                    active: true
                }
            ],
            select_all: false,
            checkbox_id: [],
            changeFormat: {
                stringify: (date) => {
                    if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Promotion.form
            },
            optionSeller: state => {
                return [
                    {
                        value: null,
                        text: "เลือกเซลล์"
                    },
                    ...state.Seller.data.map(data => ({
                        value: data.id,
                        text: data.sale_id + ' - ' + data.name
                    }))
                ];
            },
            optionProductType: state => {
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            promotion: state => {
                return [
                    ...state.Promotion.condition.map(data => ({
                        value: data.id,
                        text: data.name
                    }))
                ];
            },
        }),
        selectAll: {
            get: function () {
                return this.productAll ? this.form.checked.length >= this.productAll.length : false;
            },
            set: function (value) {
                if (value) {
                    this.select_all = true;
                    this.$store.dispatch("Promotion/selectAllProducts", {
                        code: this.search_product.code,
                        type: this.search_product.type
                    }).then(data => {
                        // //console.log(data);
                        this.form.checked = data;
                    })
                } else {
                    this.select_all = false;
                    this.form.checked = [];
                }
            }
        },
    },
    methods: {
        removeDetails(index) {
            this.$store.dispatch("Promotion/removeDetails", index);
        },
        savePromotion() {
            if (!this.form.name) {
                alert('กรุณาใส่ชื่อโปรโมชั่น')
            } else if (!this.form.quantity || this.form.quantity < 0) {
                alert("กรุณาใส่จำนวนขั้นต่ำ")
            } else if (!this.form.discount || !this.form.discount < 0) {
                alert("กรุณาใส่จำนวนส่วนลด")
            } else {
                if (this.form.checked.length > 0) {
                    this.form.checked.forEach(data => {
                        this.checkbox_id.push(data.id);
                    });
                    this.form.promotion_products = this.checkbox_id;
                } else {
                    this.form.promotion_products = [];
                }
                if (this.form.start_date) {
                    this.form.start_date = moment(this.form.start_date).format("YYYY-MM-DD");
                }
                if (this.form.end_date) {
                    this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");
                }
                //console.log(this.form);
                this.form.onSave = true;
                this.$store.dispatch("Promotion/savePromotion", {
                    id: this.id,
                    data: this.form
                });
                this.goToPromotionList();
            }
        },
        goToPromotionList() {
            this.$store.dispatch("Promotion/setPromotion").then(() => {
                this.form.onSave = false;
                this.$router.push({
                    name: "promotions-list"
                });
            });
        },
        searchProduct(page = 1) {
            this.event_submit = true;
            if (this.search_product.type === null) {
                this.search_product.type = "";
            }
            this.$store.dispatch("Products/search", {
                page: page,
                code: this.search_product.code,
                type: this.search_product.type
            }).then(res => {
                this.productAll = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        getProductPage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                this.searchProduct(page);
            } else {
                this.$store.dispatch("Products/setProducts", page).then(res => {
                    this.ProductAll = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
